import { Building2 } from "lucide-react";
import { useState } from "react";
import { cn } from "@/lib/utils";
import { isDevS3File } from "@/lib/url-utils";

interface CompanyAvatarProps {
  companyFiles?: { file_type: string; file_url?: string }[];
  websiteUrl?: string;
  alt: string;
  className?: string;
  iconClassName?: string;
}

export function CompanyAvatar({
  companyFiles,
  websiteUrl,
  alt,
  className = "h-8 w-8",
  iconClassName = "h-5 w-5",
}: CompanyAvatarProps) {
  const [imgError, setImgError] = useState(false);
  const [fallbackError, setFallbackError] = useState(false);

  const logoUrl = companyFiles?.find(
    (file) =>
      file.file_type === "company avatar" &&
      file.file_url?.match(/\.(jpg|jpeg|png|gif|webp|svg|ico)$/i) &&
      !isDevS3File(file.file_url)
  )?.file_url;

  // Extract domain from website URL for Google's favicon service
  const faviconFallbackUrl = (() => {
    if (!websiteUrl) return null;
    try {
      const domain = new URL(
        websiteUrl.startsWith("http") ? websiteUrl : `https://${websiteUrl}`
      ).hostname;
      return `https://www.google.com/s2/favicons?domain=${domain}&sz=128`;
    } catch {
      return null;
    }
  })();

  if (logoUrl && !imgError) {
    return (
      <img
        src={logoUrl}
        alt={alt}
        className={cn(className, "object-cover rounded-full")}
        onError={() => setImgError(true)}
      />
    );
  }

  if (faviconFallbackUrl && !fallbackError) {
    return (
      <img
        src={faviconFallbackUrl}
        alt={alt}
        className={cn(className, "object-cover rounded-full")}
        onError={() => setFallbackError(true)}
      />
    );
  }

  return (
    <div
      className={cn(
        className,
        "bg-[#C49733] rounded-full flex items-center justify-center"
      )}
    >
      <Building2 className={cn(iconClassName, "text-white")} />
    </div>
  );
}
